var map = {
	"./bnb.svg": 1096,
	"./bsc.png": 1097,
	"./busd.svg": 1098,
	"./coinbase.png": 1099,
	"./eth.png": 1100,
	"./fizen.png": 1101,
	"./metamask.png": 1102,
	"./polygon-matic-logo.svg": 1103,
	"./polygon.png": 1104,
	"./rainbow.png": 1105,
	"./trustwallet.png": 1106,
	"./usdt.svg": 1107,
	"./walletconnect.png": 1108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 626;